"use client";

import {JSX} from "react";

import "./styles/close-button.scss";

interface CloseButtonProps {
    onClick: () => void;
    ariaLabel?: string;
    className?: string;
}

export function CloseButton({onClick, ariaLabel = "Close", className}: CloseButtonProps): JSX.Element {
    return (
        <button type="button" className={`close-button${className ? ` ${className}` : ""}`} onClick={onClick} aria-label={ariaLabel}>
            ✕
        </button>
    );
}
